/* Copenhagen Home Design — sticky product add-to-cart.
 * The original product form remains the single source of truth.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    var formatted = '';
    if (window.Currency && window.theme && window.theme.moneyFormat) {
      formatted = window.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    if (!formatted) return '';
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (currency === 'DKK' && !/kr|DKK/i.test(formatted)) return formatted + ' kr.';
    return formatted;
  }

  function initSticky(sticky) {
    if (sticky.dataset.chdStickyInitialized) return;

    var section = sticky.closest('[data-section-type="product"]');
    var buyBox = section && section.querySelector('.product-form__buy-buttons');
    var primaryButton = buyBox && buyBox.querySelector('.product-form__add-button');
    var form = section && section.querySelector('form[action*="/cart/add"]');
    var stickyButton = sticky.querySelector('[data-chd-sticky-submit]');
    var variantLabel = sticky.querySelector('[data-chd-sticky-variant]');
    var priceLabel = sticky.querySelector('[data-chd-sticky-price]');

    if (!section || !buyBox || !primaryButton || !form || !stickyButton) return;
    sticky.dataset.chdStickyInitialized = 'true';

    function isCartOpen() {
      var miniCart = document.getElementById('mini-cart');
      return miniCart && miniCart.getAttribute('aria-hidden') === 'false';
    }

    function setVisible(visible) {
      var shouldShow = visible && !isCartOpen() && !document.querySelector('dialog[open]');
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      sticky.inert = !shouldShow;
    }

    function sync(variant) {
      var disabled = primaryButton.disabled || !primaryButton.hasAttribute('data-action');
      var variantMissing = variant === null;
      stickyButton.dataset.chdMissingVariant = variantMissing ? 'true' : 'false';
      stickyButton.disabled = disabled && !variantMissing;
      stickyButton.textContent = primaryButton.textContent.trim();

      if (variant) {
        if (variantLabel) {
          var sizeLabel = variantLabel.dataset.chdStickySizeLabel || '';
          var hasRealVariantTitle = variant.title && variant.title !== 'Default Title';
          variantLabel.hidden = !hasRealVariantTitle;
          variantLabel.textContent = hasRealVariantTitle ? (sizeLabel ? sizeLabel + ': ' : '') + variant.title : '';
        }
        if (priceLabel) priceLabel.textContent = formatMoney(variant.price) || priceLabel.textContent;
      } else if (variantMissing) {
        if (priceLabel) priceLabel.textContent = '';
        if (variantLabel) variantLabel.hidden = true;
      }
    }

    function focusVariantSelector() {
      var selector = section.querySelector('.product-form__variants, .product-form__option');
      if (!selector) return;
      selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var control = selector.querySelector('select, input:not([type="hidden"]), button');
      if (control) window.setTimeout(function () { control.focus(); }, 350);
    }

    stickyButton.addEventListener('click', function () {
      if (stickyButton.dataset.chdMissingVariant === 'true') {
        focusVariantSelector();
        return;
      }
      if (primaryButton.disabled || !primaryButton.hasAttribute('data-action')) {
        focusVariantSelector();
        return;
      }
      primaryButton.click();
    });

    section.addEventListener('variant:changed', function (event) {
      sync(event.detail && event.detail.variant);
    });

    function updateVisibilityFromPosition() {
      setVisible(primaryButton.getBoundingClientRect().bottom < 0);
    }

    var observer = new IntersectionObserver(function () {
      updateVisibilityFromPosition();
    }, { threshold: 0.15 });
    observer.observe(primaryButton);

    /* IntersectionObserver is the light primary path. The scroll fallback also
       covers theme-editor/live-preview frames where observer callbacks can be
       deferred while the preview is resizing. */
    var scrollTicking = false;
    function requestVisibilityUpdate() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        scrollTicking = false;
        updateVisibilityFromPosition();
      });
    }
    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate);
    requestVisibilityUpdate();

    var miniCart = document.getElementById('mini-cart');
    if (miniCart && window.MutationObserver) {
      new MutationObserver(function () {
        updateVisibilityFromPosition();
      }).observe(miniCart, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-chd-sticky-atc]').forEach(initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
